import React, { FunctionComponent } from "react";

import { createQA } from "@multiweb/reactUtils";
import { IOpenedFormHistoryInfo } from "@multiweb/types/contracts";
import { LOC_KEY_QUICK_ACCESS_MENU_HISTORY_ITEMS } from "../../locKeys";
import { MenuNavigationSectionType } from "../../navigation";
import { OpenedFormHistoryInfoArray } from "../../types";
import { MenuItem } from "../MenuItem";
import { ProfileItem } from "../ProfileItem";

export type QuickAccessHistoryItemsComponentProps = {
    /** Seznam formulářů otevřených v minulosti. */
    openedFormsHistoryInfo: OpenedFormHistoryInfoArray;
};

/** Vykresluje obsah části pro historicky otevřené položky v menu Rychlého přístupu. */
export const QuickAccessHistoryItemsComponent: FunctionComponent<QuickAccessHistoryItemsComponentProps> = ({ openedFormsHistoryInfo }) => (
    <div {...createQA("quick-access-history")}>
        {openedFormsHistoryInfo.map((openedFormHistoryInfo: IOpenedFormHistoryInfo) =>
            createHistoryFormComponent(openedFormHistoryInfo),
        )}
    </div>
);

/**
 * Vybere vhodný typ komponenty pro zobrazení historicky otevřeného formuláře a vytvoří ji s hodnotou klíče sestavenou podle typu.
 * @param openedFormHistoryInfo Údaje o historicky otevřeném formuláři.
 * @return Vytvořená komponenta.
 */
const createHistoryFormComponent = (openedFormHistoryInfo: IOpenedFormHistoryInfo) => {
    const { profileId, menuItemId } = openedFormHistoryInfo;
    const section = MenuNavigationSectionType.quickAccessHistoric;
    if (profileId) {
        return <ProfileItem key={`profile-${profileId}`} parentFormItemId={menuItemId} profileId={profileId} qa={LOC_KEY_QUICK_ACCESS_MENU_HISTORY_ITEMS} openActionEnabled={false} section={section}/>;
    } else {
        return <MenuItem key={`form-${menuItemId}`} formItemId={menuItemId} qa={LOC_KEY_QUICK_ACCESS_MENU_HISTORY_ITEMS} openActionEnabled={false} section={section}/>;
    }
};
